import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const fmtDate = (v) => {
  if (!v) return '';
  const [y, m, d] = String(v).slice(0, 10).split('-');
  return d ? `${d}/${m}/${y}` : v;
};

export const formatCell = (value, type) => {
  if (value === null || value === undefined || value === '') return type === 'currency' || type === 'number' ? 0 : '-';
  if (type === 'date') return fmtDate(value);
  if (type === 'currency') return Number(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return value;
};

const totalsRow = (report) => {
  if (!Object.keys(report.totals || {}).length) return null;
  return report.columns.map((c, i) => {
    if (i === 0) return 'TOTAL';
    return c.key in report.totals ? formatCell(report.totals[c.key], c.type) : '';
  });
};

const fileName = (report, ext) => `${report.title.replace(/[^a-z0-9]+/gi, '_').replace(/_+$/, '')}.${ext}`;

export const exportReportExcel = (report) => {
  const header = report.columns.map(c => c.label);
  const body = report.rows.map(r => report.columns.map(c => {
    const v = r[c.key];
    if (c.type === 'currency' || c.type === 'number') return Number(v || 0);
    return c.type === 'date' ? fmtDate(v) : (v ?? '');
  }));
  const totals = report.columns.map((c, i) => (i === 0 ? 'TOTAL' : (c.key in (report.totals || {}) ? report.totals[c.key] : '')));
  const aoa = [[report.title], [], header, ...body];
  if (Object.keys(report.totals || {}).length) aoa.push(totals);
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws['!cols'] = report.columns.map(c => ({ wch: Math.max(c.label.length + 2, c.key === 'serials' ? 40 : 14) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Report');
  XLSX.writeFile(wb, fileName(report, 'xlsx'));
};

export const exportReportPDF = (report, businessName) => {
  const doc = new jsPDF({ orientation: report.columns.length > 6 ? 'landscape' : 'portrait', unit: 'pt', format: 'a4' });
  const width = doc.internal.pageSize.getWidth();
  doc.setFontSize(14);
  doc.text(businessName || 'Report', 40, 40);
  doc.setFontSize(11);
  doc.text(report.title, 40, 58);
  doc.setFontSize(8);
  doc.text(`Generated: ${new Date().toLocaleString('en-IN')}`, width - 40, 40, { align: 'right' });
  const foot = totalsRow(report);
  autoTable(doc, {
    startY: 72,
    head: [report.columns.map(c => c.label)],
    body: report.rows.map(r => report.columns.map(c => String(formatCell(r[c.key], c.type)))),
    foot: foot ? [foot.map(String)] : undefined,
    styles: { fontSize: 7, cellPadding: 3 },
    headStyles: { fillColor: [30, 64, 175] },
    footStyles: { fillColor: [241, 245, 249], textColor: [15, 23, 42], fontStyle: 'bold' },
    columnStyles: Object.fromEntries(report.columns.map((c, i) => [i, c.type === 'currency' || c.type === 'number' ? { halign: 'right' } : {}])),
  });
  doc.save(fileName(report, 'pdf'));
};
